export function onLoadFunction() {
	let timer = setInterval(() => {
		let element = document.getElementById('mainNavbar');
		if (element) {
			document.getElementById('body').style.paddingTop = element.offsetHeight + 'px';
			clearInterval(timer);
		}
	}, 10);
}
